import type { QuickSuggestion, ContactCTA } from '@brochure/shared'

/**
 * Quick suggestion buttons shown when the chat is empty.
 * Each entry uses i18n translation keys for label and message.
 */
export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'services',
    labelKey: 'chatbot.suggestions.services.label',
    messageKey: 'chatbot.suggestions.services.message',
  },
  {
    id: 'pharma',
    labelKey: 'chatbot.suggestions.pharma.label',
    messageKey: 'chatbot.suggestions.pharma.message',
  },
  {
    id: 'certifications',
    labelKey: 'chatbot.suggestions.certifications.label',
    messageKey: 'chatbot.suggestions.certifications.message',
  },
  {
    id: 'quote',
    labelKey: 'chatbot.suggestions.quote.label',
    messageKey: 'chatbot.suggestions.quote.message',
  },
]

/**
 * Contact CTA buttons shown below each assistant message.
 */
export const contactCTAs: ContactCTA[] = [
  {
    kind: 'copy',
    id: 'phone',
    labelKey: 'chatbot.cta.phone',
    value: '+39 049 713411',
  },
  {
    kind: 'copy',
    id: 'email',
    labelKey: 'chatbot.cta.email',
    value: 'info@chiggiatospa.com',
  },
]
